import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PaymentFailedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('payment_id');

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>😔</div>
        <h2 style={styles.title}>Payment Failed</h2>
        <p style={styles.subtitle}>
          Your payment could not be completed. No amount has been deducted from your account.
        </p>
        
        {paymentId && (
          <p style={styles.refId}>
            Reference ID: {paymentId}
          </p>
        )}

        <div style={styles.reasons}>
          <p style={styles.reasonsTitle}>This could happen due to:</p>
          <ul style={styles.reasonsList}>
            <li>Insufficient balance in your eSewa wallet</li>
            <li>Transaction was cancelled</li>
            <li>Session timeout</li>
            <li>Network connectivity issues</li>
          </ul>
        </div>

        <div style={styles.buttonGroup}>
          <button 
            onClick={() => navigate('/subscription')}
            style={styles.primaryBtn}
          >
            Try Again
          </button>
          <button 
            onClick={() => navigate('/dashboard')}
            style={styles.secondaryBtn}
          >
            Go to Dashboard
          </button>
        </div>

        <p style={styles.supportNote}>
          Need help? <a href="/contact" style={styles.link}>Contact Support</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
    padding: '20px',
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '24px',
    padding: '50px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
  },
  icon: {
    fontSize: '70px',
    marginBottom: '20px',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#dc2626',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#64748b',
    marginBottom: '20px',
  },
  refId: {
    fontSize: '13px',
    color: '#94a3b8',
    marginBottom: '25px',
    fontFamily: 'monospace',
  },
  reasons: {
    backgroundColor: '#fef2f2',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '30px',
    textAlign: 'left',
  },
  reasonsTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#991b1b',
    marginBottom: '10px',
  },
  reasonsList: {
    margin: 0,
    paddingLeft: '20px',
    fontSize: '13px',
    color: '#b91c1c',
    lineHeight: 1.8,
  },
  buttonGroup: {
    display: 'flex',
    gap: '15px',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  primaryBtn: {
    flex: 1,
    minWidth: '150px',
    padding: '14px 24px',
    backgroundColor: '#60bb46',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  secondaryBtn: {
    flex: 1,
    minWidth: '150px',
    padding: '14px 24px',
    backgroundColor: '#fff',
    color: '#64748b',
    border: '2px solid #e2e8f0',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  supportNote: {
    marginTop: '25px',
    fontSize: '14px',
    color: '#64748b',
  },
  link: {
    color: '#60bb46',
    textDecoration: 'none',
    fontWeight: '600',
  },
};